<template>
  <div class="g-menu-container">
    <div class="g-menu-header">
      
      <!-- Botão para mostrar menu lateral mobile -->
      <PButton icon="pi pi-bars" @click="menuVisivel = true" class="p-button-text"></PButton>
      
      <div class="representante-empresa-container">
        <div>{{ empresaSelecionadaNome }}</div>
        <div>{{ representanteSelecionadoNome }}</div>
      </div>

      <VMenu :distance="10" class="gerenciamento" v-if="hasClaim('adm') || this.TypeGerenciamento == true">
        <div class="gerenciamentoescrito"> Gerenciamento </div>
        <template #popper>
          <div class="container-itens-popper">
            <div  v-for="item in itensGerenc" 
              :key="item.rota"> 
              <div
              v-if="item.possuiAcesso"
              :class="`botoes ${ativo(item.rota)}`"
              v-on:click="redirecionar(item.rota)">{{item.titulo}}</div>
            </div>
            
          </div>
        </template>
      </VMenu>

      <div v-on:click="ajuda" class="ajuda">Ajuda</div>

      <!-- Logo jauense lado esquerdo superior -->
      <img v-on:click="retornaDashboard" class="g-menu-logo" src="../../assets/imgs/grupo_jauense_logo_sidebar.svg" />

      <div class="g-menu-botao-user">
        <!-- Balão que direciona ao meu perfil -->
        <VDropdown :distance="6">
          <PButton icon="pi pi-user" class="p-button-rounded p-button-sm g-menu-botao-user"></PButton>

          <template #popper>
            <div class="bem-vindo-tudo">
              <div class="bem-vindo">Bem vindo,</div>
              <div class="bem-vindo">{{dadosUsuario.nome}}!</div>
            </div>

            <div class="meu-perfil" @click="meuperfil">
              <div class="pi pi-user icone"></div>
              <div class="meu-perfil-botao">Meu Perfil</div>
              <div class="pi pi-chevron-right chave-lateral"></div>
            </div>
            
            <div class="meu-perfil" @click="enviarCRM">
              <div class="pi pi-user icone"></div>
              <div class="meu-perfil-botao">CRM</div>
              <div class="pi pi-chevron-right chave-lateral"></div>
            </div>

            <div class="sair-tudo" @click="abrirpopupsair">
              <div class="pi pi-sign-out icone-sair"></div>
              <div class="sair-escrito">Sair</div>
              <div class="pi pi-chevron-right chave-lateral-sair"></div>
            </div>

            <!-- Popup confirmação saída -->
            <PDialog class="popupsair" :closable="false" :showHeader="false" v-model:visible="popupsair" :modal="true">
              <div class="titulo-popup-finalizado">Você deseja mesmo sair?</div>
              <div class="botoes-popup">
                <div class="btnNao">
                  <g-button 
                  tipo="cinza"
                  negritoTexto 
                  largura="200px" 
                  altura="35px"
                  @click="fecharpopupsair">
                    NÃO
                  </g-button>
                </div>
                <div class="btnSim">
                  <g-button 
                  tipo="amarelo"
                  negritoTexto
                  largura="200px" 
                  altura="35px" 
                  @click="deslogar">
                    SIM
                  </g-button>
                </div>
              </div>

            </PDialog>
          </template>
        </VDropdown>
      </div>

      <!-- Botão configuracao -->
      <div class="g-menu-botao-config" @click="unidadeRepresentanteMenu = true">
        <VDropdown
          :distance="6"
          :shown="unidadeRepresentanteMenu"
          :autoHide="false">
          <PButton icon="pi pi-cog" class="p-button-rounded p-button-sm g-menu-botao-config"></PButton>

          <template #popper>
            <div class="menu-container">
              <div class="configuracoestudo">
                <div class="titulo-configuracoes">Configurações</div>
              </div>
              <div class="meu-perfil">
                <div class="meu-perfil-botao">Unidade</div>
              </div>
                <div class="dropDownEmpresa">
                  <PDropDown
                    v-model="empresaSelecionadaId"
                    :options="EmpresaArray"
                    optionLabel="nome"
                    optionValue="id"
                    placeholder="Selecione uma empresa"
                    :class="`drop-down-menu ${!representanteEEmpresaSelecionados && camposPreenchidos && tentouFechar ? 'p-invalid' : ''}`"
                    :filter="true"
                    @filter="buscarEmpresa($event.value)"
                >
                  <template #option="slotProps">
                    <div class="engloba-opcao">
                      {{ slotProps.option.nome }}
                    </div>
                  </template>
                </PDropDown>
                </div>
              <div class="representante">
                <div class="meu-perfil-botao">Representante</div>
              </div>
              <div class="dropDownRepresentante">
                <PDropDown
                  v-model="representanteSelecionadoId"
                  :options="RepresentanteArray"
                  :disabled="!empresaSelecionadaId"
                  optionLabel="codigoNomeRepresentante"
                  optionValue="representanteId"
                  placeholder="Selecione um representante"
                  :class="`drop-down-menu ${!representanteEEmpresaSelecionados && camposPreenchidos && tentouFechar ? 'p-invalid' : ''}`"
                  @filter="buscarRepresentante($event.value)"
                  :filter="true"
                />
              </div>

              <div class="engloba-botoes-menu">
                <div class="botaoCancelar">
                  <g-button largura="245px" negritoTexto tipo="cinza" @click="fecharMenuSuperior">
                    CANCELAR
                  </g-button>
                </div>
                <div class="botaoConfirmar">
                  <g-button largura="245px" negritoTexto @click="salvarUnidadeRepresentante">
                    CONFIRMAR
                  </g-button>
                </div>
              </div>
            </div>

          </template>
        </VDropdown>
      </div>

      <!-- Menu lateral mobile -->
      <PSideBar class="g-menu-sidebar" id="sideBar" v-model:visible="menuVisivel" position="left"
        :showCloseIcon="false">
        <template #header>
          <div class="conteudo-cabecalho">
            <PButton icon="pi pi-bars" @click="menuVisivel = false" class="p-button-text botao-barras-interno">
            </PButton>
            <img class="g-menu-logo" src="../../assets/imgs/grupo_jauense_logo_sidebar.svg" />
          </div>
        </template>
        <div id="container-items-menus">
          <g-menu-item v-for="item in itensMenu" :key="item.id" :titulo="item.titulo" :subItens="item.subItens"
            :idItem="item.id" v-on:acao="selecionarPagina"></g-menu-item>
        </div>
      </PSideBar>
    </div>
  </div>


</template>

<script>
import gMenu from "./g-menu.js";
export default gMenu;
</script>

<style scoped>
.titulo-configuracoes{
  margin-right: 5px;
  font-family: "MontSerrat";
  font-size: 18px;
  color: #4f2c19;
  font-weight: bold;
}
.botaoConfirmar{
  margin-top: 19px;
  margin-bottom: 15px;
}

.botaoCancelar{
  margin-top: 19px;
}

.dropDownEmpresa{
  margin-left: 19px;
  margin-right: 19px
}

.representante {
  display: flex;
  margin: 10px;
  cursor: pointer;
  margin-top: 15px;
}

.dropDownRepresentante{
  margin-left: 19px;
  margin-right: 19px;
}

.configuracoestudo{
  margin-left: 19px;
  margin-top: 15px;
}

.container-itens-popper{
  width: 100%;
  max-width: 500px;
  padding: 15px 10px;

}

.botoes {
  font-family: 'MontSerrat' !important;
  width: fit-content;
  text-align: left;
  font-style: bold;
  color: #A8A8A8;
  background: white;
  border-color: white;
  box-shadow: none;
  display: block;
  padding: 0.2rem;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
}

.botoes:hover {
  color: #4F2C19;
  cursor: pointer;
}


.botoes.ativo {
    border: 10px;
    color: #4F2C19;
    text-decoration: underline;
    font-weight: bold;
}

.p-button:enabled:hover {
     color: black;
    background: white;
    border-color: white;
    box-shadow: none;
}

.item-pai.ativo{
    color: #4F2C19;
    font-weight: bold;
    border-top: 2px #FCB315 solid;

}

.bem-vindo-tudo {
  display: flex;
  padding: 0.5rem;
}

.bem-vindo {
  margin-right: 5px;
  font-family: "MontSerrat";
  color: #4f2c19;
  font-weight: bold;
  font-size: 15px;
}

.sair-tudo {
  display: flex;
  margin-left: 10px;
  cursor: pointer;
  margin-bottom: 5px;
}

.meu-perfil {
  display: flex;
  margin: 10px;
  cursor: pointer;
}

.icone {
  color: #fcb315;
}

.icone-sair {
  color: #fcb315;
}

.chave-lateral {
  margin-left: 0px;
  margin-top: 2px;
  width: 10px;
  color: #3e3e3e;
}

.chave-lateral-sair {
  margin-left: 0px;
  margin-top: 2px;
  color: #3e3e3e;
  width: 10px;
}

.meu-perfil-botao {
  font-size: 15px;
  font-family: "MontSerrat";
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  color: #3e3e3e;
}

.sair-escrito {
  font-size: 15px;
  font-family: "MontSerrat";
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  color: #3e3e3e;
}

:global(.p-sidebar .p-sidebar-header) {
  display: block;
  background-color: #4f2c19;
}

:global(.g-menu-sidebar.p-sidebar .p-sidebar-content) {
  padding: 5px;
}

:global(.botao-barras-interno.p-button:focus) {
  border-color: none !important;
  box-shadow: none !important;
}

.g-menu-container {
  width: 100%;
  height: 60px;
  padding: 1px 15px 1px 15px;
  background-color: #4f2c19;
}

.g-menu-header {
  height: 60px;
  width: 100%;
  display: grid;
  align-items: center;
  justify-content: center;
  column-gap: 5px;
  grid-template-columns: 10% 70% 10% 10%;
  grid-template-rows: 1fr;
  grid-template-areas: "botao_menu logo_jauense_menu botao_user botao_config";
}

.p-button {
  color: black;
}

.g-menu-botao-config{
  grid-area: botao_config;
}

button.p-button.p-component.p-button-icon-only.p-button-text{
  color: white;
  display: flex ;
  align-items: center ;
  justify-content: center ;
}

.g-menu-logo {
  width: 100px;
  grid-area: logo_jauense_menu;
}

.p-button-rounded {
  background-color: #fcb315;
  color: #4f2c19 !important;
  width: 100px;
}

.p-button:not(.g-button-container) {
  width: 30px !important;
  height: 30px !important;
  border-color: transparent !important;
}

.p-button-rounded:focus {
  border-color: transparent !important;
  box-shadow: none !important;
}

.p-button-rounded:hover {
  background-color: #fcb315 !important;
}

.p-button-text {
  grid-area: botao_menu;
}

.g-menu-botao-user {
  grid-area: botao_user;
}

.g-menu-botao_config {
  grid-area: botao_config;
}

.conteudo-cabecalho {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.gerenciamento {
  display: none;
  cursor: pointer;
}

.ajuda {
  display: none;
  cursor: pointer;
}

.titulo-popup {
  font-family: "MontSerrat";
  font-size: 15px;
  margin-top: 15px;
}

.container-botoes{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-top: 15px;

}

.input-representante {
    width: 100%;
}

.drop-down-menu{
  width: 100%;
  max-width: 300px;
}

.engloba-botoes-menu{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.menu-container{
  padding: 0.5rem;
  width: 300px;
}

.representante-empresa-container{
  display: flex; 
  justify-content: center;
  color: #fcb315; 
  gap: 2rem;
  font-weight: 700;
}

@media (min-width: 310px) {
  .p-button-text {
    display: block;
  }
  .representante-empresa-container{
    display: none;
  }
}

@media (min-width: 368px) {
  .g-menu-header {
    grid-template-columns: 10% 70% 10% 10%;
    grid-template-areas: "botao_menu logo_jauense_menu botao_user botao_config";
  }
}

@media (min-width: 600px) {
  .g-menu-header {
    /* grid-template-columns: 10% 70% 10% 10%;
    grid-template-areas: "botao_menu logo_jauense_menu representante-empresa-container botao_user botao_config";  */
    /* grid-template-columns: 4% 16% 60% 10% 10%; */
    grid-template-columns: 5% 12% 66% 10% 7%;
    grid-template-areas: "botao_menu logo_jauense_menu representante-empresa-container botao_user botao_config";
  }

  
  .representante-empresa-container{
    display: block;
    font-size: 13px;
  }
}

@media (min-width: 801px) {
  /* .g-menu-header {
    grid-template-columns: 10% 70% 10% 10%;

    grid-template-areas: "botao_menu logo_jauense_menu botao_user botao_config";
  } */

  .representante-empresa-container{
    font-size: 16px;
  }
}

@media (min-width: 1025px) {
  :deep(button.p-button.p-component.p-button-icon-only.p-button-text){
    display: none;
  }

  .g-menu-header {
    /* grid-template-columns: 70% 10% 5% 5%; */
    grid-template-columns: 16% 58% 10% 6% 5%;
    grid-template-areas: "logo_jauense_menu representante-empresa-container gerenciamento ajuda botao_user botao_config";
  }

  .gerenciamento{
    display: inline;


  }

  .gerenciamentoescrito {
    grid-area: gerenciamento;
    display: inline;
    color: white;
  }

  .ajuda {
    display: inline;
    color: white;
    grid-area: ajuda;
  }
}

@media (min-width: 1281px) {
}
.engloba-opcao{
  max-width: 220px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
